import { useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useMutation, useQuery } from "@tanstack/react-query";

import { SaveButton } from "ui-components/Form";
import { Layout } from "ui-components/Layout";
import { Success, Error_ } from "ui-components/Alert";
import { formRender, initialValues, packagingMaterialValidation } from "./packaging-material-schema";
import { getPackagingMaterial, editPackagingMaterial } from "services/data.internal.service";
import PackagingMaterialInfo from "./components/PackagingMaterialInfo";
import { useLocation } from "react-router-dom";

function EditPackagingMaterial() {
  const location = useLocation();
  const { materialName } = location.state;
  const [alert, setAlert] = useState(null);
  const [formValues, setFormValues] = useState(null)
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  useQuery({
    queryKey: ["packaging-material", { materialName }],
    queryFn: () => getPackagingMaterial({ materialName }),
    onSuccess: (data) => setFormValues(data.data.data),
    onError,
  });

  const editPackagingMaterialMutation = useMutation(editPackagingMaterial, {
    onSuccess: (data) => {
      setAlert(<Success data={data} onChange={setAlert} />);
    },
    onError,
  });
  const form = useForm({
    defaultValues: initialValues,
    values:formValues,
    resolver: yupResolver(packagingMaterialValidation),
  });

  const {
    control,
    handleSubmit,
    formState: { errors, isDirty, isSubmitting },
    setValue,
    reset,
  } = form;

  const infoProps = {
    mode: "EDIT",
    control,
    errors,
    setValue,
    formRender,
  };
  const onSubmit = (data) => {
    editPackagingMaterialMutation.mutate(data, {
      onSuccess: () => {
      },
    });
  };
  const editStatus = editPackagingMaterialMutation.status === "loading";
  return (
    <Layout>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <PackagingMaterialInfo {...infoProps} />
        <SaveButton label="Save" disabled={!isDirty && editStatus} url="/setup/packaging-material" />
      </form>
    </Layout>
  );
}

export default EditPackagingMaterial;
